import { createContext, useContext, useState } from 'react';

const SearchResultsContext = createContext();

export const SearchResultsProvider = ({ children }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [searchType, setSearchType] = useState('');
  const [searchMetadata, setSearchMetadata] = useState({});

  return (
    <SearchResultsContext.Provider 
      value={{ 
        searchResults, 
        setSearchResults,
        searchType,
        setSearchType,
        searchMetadata,
        setSearchMetadata
      }}
    >
      {children}
    </SearchResultsContext.Provider>
  );
};

export const useSearchResults = () => useContext(SearchResultsContext);